import React, { useEffect, useState } from "react";
import { FormSelect } from "ui-kit-ck-consultant";

import axiosConfig from "../../utils/axiosConfig";

// Experts who can hold a folder's RDV (expert types with XpertVisio access).
const ExpertSelect = ({ value = "", onChange }) => {
  const [experts, setExperts] = useState([]);

  useEffect(() => {
    axiosConfig("folder/get-folder-owners")
      .then((res) => {
        if (res.data && res.data.success) {
          setExperts(res.data.owners);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <FormSelect
      title="Expert du rendez-vous"
      value={value}
      name="expertId"
      init="Sélectionner un expert"
      options={experts.map((expert) => ({
        value: expert.id.toString(),
        text: expert.agencyName
          ? `${expert.name} (${expert.agencyName})`
          : expert.name,
      }))}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export default ExpertSelect;
